import { render, staticRenderFns } from "./recordDetails.vue?vue&type=template&id=2895b8ff&scoped=true"
import script from "./recordDetails.vue?vue&type=script&lang=js"
export * from "./recordDetails.vue?vue&type=script&lang=js"
import style0 from "./recordDetails.vue?vue&type=style&index=0&id=2895b8ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895b8ff",
  null
  
)

export default component.exports